export const test = {
  injectProps: {
    a: 'b',
  },
};
